export default __webpack_public_path__ + "static/media/plumbing2.5f7d1534.jpeg";